import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { BuletineTableService } from 'src/app/modules/acbcr/common/services/buletine-table.service';
import { AnimalsTableService } from 'src/app/modules/acbcr/common/services/animals-table.service';

@Component({
  selector: 'app-fisa-bonitare',
  templateUrl: './fisa-bonitare.component.html',
  styles: [
  ]
})
export class FisaBonitareComponent {
  @ViewChild('fisaBonitareModal') fisaBonitareModal: ElementRef;
  @Input() modalData: any;

  modalReference: NgbModalRef;
  isAdmin = false;
  isOperator = false;
  fisaBonitareForm = new UntypedFormGroup({});
  bonitori;

  constructor(
    public modalService: NgbModal,
    private helperDataService: HelperDataService,
    private buletinTabelService: BuletineTableService,
    private animalsTableService: AnimalsTableService,
  ) { }

  ngOnInit() {
    this.isAdmin = UIHelper.isAdmin();
    this.isOperator = UIHelper.isOperator();
    this.buildForm();
  }

  ngOnChanges(changes) {
    if (changes.modalData && this.modalData) {
      this.openModal();

      if (! this.bonitori) {
        this.buletinTabelService.operatoriAPI().subscribe(
          (response) => {
            this.bonitori = response;
          });
      }

      this.buildForm();
    }
  }

  buildForm() {
    this.modalData = this.modalData || {};

    if (this.isAdmin || this.isOperator) {
      this.modalData['bonitor_id'] = UIHelper.userId()
    }

    this.fisaBonitareForm = new UntypedFormGroup({
      animal_id: new UntypedFormControl(this.modalData['animal_id']),
      data: new UntypedFormControl(),
      bonitor_id: new UntypedFormControl(this.modalData['bonitor_id']),
    });
  }

  openModal() {
    this.modalReference = this.modalService.open(this.fisaBonitareModal, {
      windowClass: 'modal-half-full',
      scrollable: true,
    });
  }

  onDateChanged(event) {
    this.fisaBonitareForm.controls.data.setValue(event);
  }

  onSubmitted() {
    let numarmatricol = this.modalData['numarmatricol'];
    let fisier = `Fisa_bonitare_${numarmatricol}.pdf`;

    this.animalsTableService
      .FisaBonitareDownloadAPI(this.fisaBonitareForm.value)
      .subscribe({
        next: (response) => {
          const blob = new Blob([response]);
          this.helperDataService.simulateDownload(blob, fisier);
        }
      })
  }
}
